import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { Button } from './ui/Button';
function useCountdown(hours: number) {
  const [endTime] = useState(() => {
    const stored = localStorage.getItem('cta-countdown-end');
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (parsed > Date.now()) return parsed;
    }
    const end = Date.now() + hours * 60 * 60 * 1000;
    localStorage.setItem('cta-countdown-end', String(end));
    return end;
  });
  const [timeLeft, setTimeLeft] = useState(() => Math.max(0, endTime - Date.now()));
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const totalSeconds = Math.floor(timeLeft / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor(totalSeconds % 3600 / 60);
  const s = totalSeconds % 60;
  return {
    hours: h,
    minutes: m,
    seconds: s,
    isExpired: timeLeft <= 0
  };
}
export function Hero() {
  const countdown = useCountdown(5);
  const scrollToCTA = () => {
    document.getElementById('cta-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/cFUfdYme6KXfWBA96LUGay/heylloyd-image-1774468813334.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-236">
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-stone-900/60" data-id="element-237" />
      {/* Gradient overlay at bottom for smooth transition */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-stone-50 to-transparent" data-id="element-238" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-24 md:py-32 text-center" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-240">
          {/* Countdown Timer */}
          {!countdown.isExpired && <div className="backdrop-blur-md rounded-2xl p-5 md:p-6 text-center shadow-lg mb-8 border border-white/10 bg-[#34D39949]" data-id="element-241">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-242">
                <Clock className="w-4 h-4 text-amber-400" data-id="element-243" />
                <span className="text-amber-400 font-bold md:text-sm uppercase tracking-wider text-[16px]" data-id="element-244">
                  Oferta válida por tiempo limitado
                </span>
                <Clock className="w-4 h-4 text-amber-400" data-id="element-245" />
              </div>
              <div className="flex md:gap-3 gap-[15px] flex-row items-center justify-center" data-id="element-246">
                <div className="bg-white/10 rounded-xl px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[72px]" data-id="element-247">
                  <span className="text-2xl md:text-3xl font-bold text-white tabular-nums" data-id="element-248">
                    {String(countdown.hours).padStart(2, '0')}
                  </span>
                  <span className="block text-[10px] md:text-xs text-stone-400 uppercase tracking-wider mt-1" data-id="element-249">
                    Horas
                  </span>
                </div>
                <span className="text-xl font-bold text-white/40" data-id="element-250">:</span>
                <div className="bg-white/10 rounded-xl px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[72px]" data-id="element-251">
                  <span className="text-2xl md:text-3xl font-bold text-white tabular-nums" data-id="element-252">
                    {String(countdown.minutes).padStart(2, '0')}
                  </span>
                  <span className="block text-[10px] md:text-xs text-stone-400 uppercase tracking-wider mt-1" data-id="element-253">
                    Min
                  </span>
                </div>
                <span className="text-xl font-bold text-white/40" data-id="element-254">:</span>
                <div className="bg-white/10 rounded-xl px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[72px] pl-[16px] pr-[16px]" data-id="element-255">
                  <span className="text-2xl md:text-3xl font-bold text-white tabular-nums" data-id="element-256">
                    {String(countdown.seconds).padStart(2, '0')}
                  </span>
                  <span className="block text-[10px] md:text-xs text-stone-400 uppercase tracking-wider mt-1" data-id="element-257">
                    Seg
                  </span>
                </div>
              </div>
              <p className="text-xs md:text-sm mt-3 text-[#000000]" data-id="element-258">
                Aprovechá el{' '}
                <span className="text-emerald-400 font-bold" data-id="element-259">50% OFF</span>{' '}
                antes de que termine el tiempo
              </p>
            </div>}

          <span className="inline-block py-1.5 px-4 rounded-full bg-emerald-500/20 text-emerald-300 text-sm font-semibold tracking-wide backdrop-blur-sm border border-emerald-400/20 pt-[6px] pb-[6px] mt-[6px] mb-[6px]" data-id="element-260">
            NUEVO PROTOCOLO
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-261">
            El Protocolo Anti-Inflamación:{' '}
            <span className="text-emerald-400" data-id="element-262">
              El Plan de 30 Días para Recuperar tu Abdomen
            </span>
          </h1>
          <p className="text-lg md:text-xl text-stone-200 mb-10 max-w-2xl mx-auto" data-id="element-263">
            Apaga la señal de estrés de tu cuerpo, elimina la retención de
            líquidos y vuelve a cerrar ese pantalón en solo 72 horas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-264">
            <Button size="lg" onClick={scrollToCTA} data-id="element-265">
              QUIERO DESINFLAMARME AHORA
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}